<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'PATIENT-MERGE'" [breadcrumb]="''" [count]=""
    icon="fa-code-merge">
</app-breadcrumb>

<kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
    <kendo-tabstrip-tab title="{{ 'PATIENT-MERGE' | translate:patientLabel }}" [selected]="true">
        <ng-template kendoTabContent>
            <div class="content-background p-0">
                <!--Merge stepper-->
                <kendo-stepper class="mt-4 mb-4" [steps]="steps" [stepType]="'full'" [currentStep]="currentStep"
                    [linear]="true" [style.width.%]="100" (activate)="activateStep($event)"
                    (currentStepChange)="currentStepChange($event)">
                </kendo-stepper>
                <!--Confirmation Step-->
                <div *ngIf="currentStep === 3" class="mt-5">
                    <div class="row">
                        <div class="col-2 offset-2 text-right p-0">
                            <i class="fas fa-exclamation-triangle icon-warn fa-1_5x"></i>
                        </div>
                        <div class="col-5">
                            <label class="k-form-field">
                                <span class="k-text-uppercase icon-warn text-center" *ngIf="!hasOpenBatch">
                                    {{'PATIENT-MERGE-WARNING' | translate:patientLabel}}
                                </span>
                                <span class="k-text-uppercase icon-warn text-center" *ngIf="hasOpenBatch">
                                    {{'SOURCE-PATIENT-HAS-OPEN-BATCH' | translate:patientLabel}}
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="row mt-4 mb-4 justify-content-center" *ngIf="!hasOpenBatch">
                        <input type="checkbox" id="mergeConfirmation" [(ngModel)]="mergeConfirmed" kendoCheckBox />
                        <label class="k-checkbox-label font-weight-bold emphasizedLabel k-text-uppercase"
                            style="font-size: large;line-height: initial; margin-top:-2px" for="mergeConfirmation">
                            {{ 'PATIENT-MERGE-CONFIRMATION' | translate:patientLabel }}
                        </label>
                    </div>
                    <div class="row justify-content-center">
                        <button [disabled]="merging" class="k-button mr-3 mt-2" (click)="onCancelConfirmation()">
                            {{ 'CANCEL' | translate }}
                        </button>
                        <button kendoButton appPreventClick (click)="executeMerge()" *ngIf="!hasOpenBatch"
                            [disabled]="merging || !mergeConfirmed" [primary]="true" class="float-center mt-2">
                            <span class="pl-2">{{ 'PATIENT-MERGE-PROCESS' | translate }}</span>
                            <i class="far fa-code-merge" *ngIf="!merging" style="width:25px"></i>
                            <i class="k-icon k-i-loading" *ngIf="merging" style="width:25px"></i>
                        </button>
                    </div>
                    <hr class="mt-4 mb-4">
                </div>
                <!--Merge Source and Target-->
                <div class="row m-1">
                    <div class="col-6">
                        <app-patient-merge-selector [context]="'source'" #sourceSelector
                            [searchEnabled]="currentStep === 0" [defaultOperator]="selectSourceOperator"
                            [excludeId]="null" [propertiesSelectorVisible]="currentStep >= 2"
                            [propertiesSelectorEnabled]="currentStep === 2"
                            (operatorChange)="selectSourceOperator=$event"
                            (subjectChange)="selectSourceSubject=$event; selectDefaultSubject=$event">
                        </app-patient-merge-selector>
                    </div>
                    <div class="col-6">
                        <i class="fas fa-exchange-alt fa-lg pointer exchange-patient-selection"
                            title="{{ 'PATIENT-MERGE-INVERT-SELECTION' | translate }}" (click)="invertSubject()"
                            *ngIf="(currentStep === 1 || currentStep === 2) && selectTargetSubject !== null">
                        </i>
                        <app-patient-merge-selector [context]="'target'" #targetSelector
                            [searchEnabled]="currentStep === 1" [defaultOperator]="selectTargetOperator"
                            [defaultSubject]="selectDefaultSubject" [disabledToggleOnView]="disabledToggleOnView"
                            [excludeId]="selectSourceSubject !== null ? selectSourceSubject.id : null"
                            (operatorChange)="selectTargetOperator=$event" (subjectChange)="selectTargetSubject=$event"
                            *ngIf="currentStep >= 1">
                        </app-patient-merge-selector>
                    </div>
                </div>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="{{ 'PATIENT-DUPLICATES' | translate:patientLabel }}">
        <ng-template kendoTabContent>
            <div class="mt-3 ml-3 mr-3">
                <button kendoButton [primary]="true" type="button"
                    [disabled]="selectedMemberKeys.length !== 1 && selectedMemberKeys.length !== 2"
                    (click)="selectMembers()">
                    {{'SELECT-MEMBERS' | translate:patientLabel }}<span
                        *ngIf="getDuplicatedMembersSelectedCount() > 0">({{getDuplicatedMembersSelectedCount()}})</span>
                </button>
            </div>
            <div class="mt-3 ml-3 mr-3">
                <kendo-grid [data]="viewDuplicatedMembers.gridData" [selectable]="{ mode: 'multiple' }"
                    [pageable]="duplicatedMemberCount > viewDuplicatedMembers.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                    [pageSize]="viewDuplicatedMembers.state.take" [skip]="viewDuplicatedMembers.state.skip"
                    [sortable]="true" [sort]="viewDuplicatedMembers.state.sort" [resizable]="true"
                    [kendoGridSelectBy]="'id'" [selectedKeys]="selectedMemberKeys" [navigable]="true"
                    (selectedKeysChange)="onSelectedKeysChange($event)" (dataStateChange)="dataStateChange($event)"
                    [loading]="viewDuplicatedMembers.loading">
                    <kendo-grid-messages noRecords="{{ 'NO-PATIENTS-DUPLICATE' | translate:patientLabel}}">
                    </kendo-grid-messages>
                    <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="false" [width]="4"
                        class="text-center" headerClass="text-center">
                    </kendo-grid-checkbox-column>
                    <kendo-grid-column field="fullName" [width]="25" title="{{ 'NAME' | translate }}">
                    </kendo-grid-column>
                    <kendo-grid-column field="streetLine" title="{{ 'ADDRESS' | translate }}" [width]="45"
                        [sortable]="false" [filterable]="false">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span>{{dataItem.streetLine}} {{dataItem.streetLineAdditional}}<br /></span>
                            <span *ngIf="dataItem.city">{{dataItem.city}}</span>
                            <span *ngIf="dataItem.county">{{dataItem.city ? ', ' + dataItem.county :
                                dataItem.county}}</span>
                            <span *ngIf="dataItem.stateCode">{{dataItem.city || dataItem.county ? ', ' +
                                dataItem.stateCode:dataItem.stateCode}}</span>
                            <span *ngIf="dataItem.postalCode">{{dataItem.city || dataItem.county || dataItem.stateCode ?
                                ', ' + dataItem.postalCode : dataItem.postalCode}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="dateOfBirth" title="{{ 'DATE-OF-BIRTH' | translate }}" [width]="15"
                        filter="date" format="{0:d}">
                        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                            <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
                                <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                                <kendo-filter-after-operator></kendo-filter-after-operator>
                                <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                                <kendo-filter-before-operator></kendo-filter-before-operator>
                            </kendo-grid-date-filter-cell>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <div
                                *ngIf="dataItem.dateOfBirth !== null && dataItem.dateOfBirth !== undefined && !viewDuplicatedMembers.loading">
                                {{ intl.formatDate(intl.parseDate(dataItem.dateOfBirth), "d") }}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="id" [width]="15" title="{{ 'ID' | translate }}">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="{{ 'MERGE-HISTORY' | translate }}">
        <ng-template kendoTabContent>
            <div class="row mt-2">
                <div class="col-sm-12">
                    <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                        <app-advanced-mode id="patientMergeHistoryGridAdvancedSwitch"
                            [storageKey]="'patients-merge-history-list'" (collapsibleToggle)="enableAdvanced=$event">
                        </app-advanced-mode>
                        <input #search kendoTextBox class="ml-4 button-search"
                            placeholder="{{ 'SEARCH-ON-TARGET-NAME' | translate }}"
                            (keyup)="searchFieldChange(search.value)"
                            title="{{ 'SEARCH-ON-TARGET-NAME' | translate }}" />
                        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
                    </div>
                </div>
            </div>
            <div class="mt-3 ml-3 mr-3">
                <kendo-grid #grid [data]="historyGridView" [navigable]="true"
                    [pageable]="historyCount > historyState.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                    [pageSize]="historyState.take" [skip]="historyState.skip" [loading]="loadingMergeHistory"
                    [sort]="historyState.sort" [filter]="historyState.filter" [sortable]="true"
                    [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
                    [reorderable]="enableAdvanced" (dataStateChange)="historyDataStateChange($event);"
                    [selectable]="{ mode: 'single' }">
                    <kendo-grid-messages noRecords="{{ 'NO-HISTORY' | translate }}">
                    </kendo-grid-messages>
                    <kendo-grid-column field="createdBy" [width]="10" title="{{ 'CREATED-BY' | translate }}">
                    </kendo-grid-column>
                    <kendo-grid-column field="createdOn" [width]="10" title="{{ 'CREATED-DATE' | translate }}"
                        filter="date" format="{0:d}">
                        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                            <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
                                <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                                <kendo-filter-after-operator></kendo-filter-after-operator>
                                <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                                <kendo-filter-before-operator></kendo-filter-before-operator>
                            </kendo-grid-date-filter-cell>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column-group title="{{'PATIENT-MERGE-SOURCE' | translate:patientLabel}}" [width]="600"
                        [locked]="false" [columnMenu]="false" headerClass="text-center">
                        <kendo-grid-column field="sourceMemberFullName" [width]="10" title="{{ 'NAME' | translate }}"
                            [width]="10">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <a *ngIf="dataItem.sourceMember.consentAllowed && !dataItem.patientRestricted"
                                    title=" {{ 'SELECT-MEMBER' | translate:patientLabel }}"
                                    [routerLink]="['/patient', dataItem.sourceMember.id]"
                                    class="pointer emphasizedLabel">
                                    {{ dataItem.sourceMember.fullName }}
                                </a>
                                <span *ngIf="!dataItem.sourceMember.consentAllowed || dataItem.patientRestricted">{{
                                    dataItem.sourceMember.fullName }}
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="sourceMemberDateOfBirth" title="{{ 'DATE-OF-BIRTH' | translate }}"
                            [width]="15" filter="date" format="{0:d}">
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
                                    <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                    <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                    <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                                    <kendo-filter-after-operator></kendo-filter-after-operator>
                                    <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                                    <kendo-filter-before-operator></kendo-filter-before-operator>
                                </kendo-grid-date-filter-cell>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div
                                    *ngIf="dataItem.sourceMemberDateOfBirth !== null && dataItem.sourceMemberDateOfBirth !== undefined && !loadingMergeHistory">
                                    {{ intl.formatDate(intl.parseDate(dataItem.sourceMemberDateOfBirth), "d") }}
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="dataItem.sourceMember.streetLine" title="{{ 'ADDRESS' | translate }}"
                            [width]="15" [sortable]="false" [filterable]="false">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span>{{dataItem.sourceMember.streetLine}}
                                    {{dataItem.sourceMember.streetLineAdditional}}<br /></span>
                                <span *ngIf="dataItem.sourceMember.city">{{dataItem.sourceMember.city}}</span>
                                <span *ngIf="dataItem.sourceMember.county">{{dataItem.sourceMember.city ? ', ' +
                                    dataItem.sourceMember.county :
                                    dataItem.sourceMember.county}}</span>
                                <span *ngIf="dataItem.sourceMember.stateCode">{{dataItem.sourceMember.city ||
                                    dataItem.sourceMember.county ? ', ' +
                                    dataItem.sourceMember.stateCode:dataItem.sourceMember.stateCode}}</span>
                                <span *ngIf="dataItem.sourceMember.postalCode">{{dataItem.sourceMember.city ||
                                    dataItem.sourceMember.county || dataItem.sourceMember.stateCode ?
                                    ', ' + dataItem.sourceMember.postalCode : dataItem.sourceMember.postalCode}}</span>
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid-column-group>
                    <kendo-grid-column-group title="{{'PATIENT-MERGE-TARGET' | translate:patientLabel}}" [width]="600"
                        [locked]="false" [columnMenu]="false" headerClass="text-center">
                        <kendo-grid-column field="targetMemberFullName" [width]="10" title="{{ 'NAME' | translate }}"
                            [width]="10">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <a *ngIf="dataItem.targetMember.consentAllowed && !dataItem.patientRestricted"
                                    title=" {{ 'SELECT-MEMBER' | translate:patientLabel }}"
                                    [routerLink]="['/patient', dataItem.targetMember.id]"
                                    class="pointer emphasizedLabel">
                                    {{ dataItem.targetMember.fullName }}
                                </a>
                                <span *ngIf="!dataItem.targetMember.consentAllowed || dataItem.patientRestricted">{{
                                    dataItem.targetMember.fullName }}
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="targetMemberDateOfBirth" title="{{ 'DATE-OF-BIRTH' | translate }}"
                            [width]="15" filter="date" format="{0:d}">
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
                                    <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                    <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                    <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                                    <kendo-filter-after-operator></kendo-filter-after-operator>
                                    <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                                    <kendo-filter-before-operator></kendo-filter-before-operator>
                                </kendo-grid-date-filter-cell>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div
                                    *ngIf="dataItem.targetMemberDateOfBirth !== null && dataItem.targetMemberDateOfBirth !== undefined && !loadingMergeHistory">
                                    {{ intl.formatDate(intl.parseDate(dataItem.targetMemberDateOfBirth), "d") }}
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="dataItem.targetMember.streetLine" title="{{ 'ADDRESS' | translate }}"
                            [width]="15" [sortable]="false" [filterable]="false">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span>{{dataItem.targetMember.streetLine}}
                                    {{dataItem.targetMember.streetLineAdditional}}<br /></span>
                                <span *ngIf="dataItem.targetMember.city">{{dataItem.targetMember.city}}</span>
                                <span *ngIf="dataItem.targetMember.county">{{dataItem.targetMember.city ? ', ' +
                                    dataItem.targetMember.county :
                                    dataItem.targetMember.county}}</span>
                                <span *ngIf="dataItem.targetMember.stateCode">{{dataItem.targetMember.city ||
                                    dataItem.targetMember.county ? ', ' +
                                    dataItem.targetMember.stateCode:dataItem.targetMember.stateCode}}</span>
                                <span *ngIf="dataItem.targetMember.postalCode">{{dataItem.targetMember.city ||
                                    dataItem.targetMember.county || dataItem.targetMember.stateCode ?
                                    ', ' + dataItem.targetMember.postalCode : dataItem.targetMember.postalCode}}</span>
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid-column-group>
                </kendo-grid>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>

<!--Merge cancellation dialog-->
<kendo-dialog *ngIf="cancelDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="cancelMerge(true)">
    <p>{{'PATIENT-MERGE-CANCEL' | translate:patientLabel}}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="cancelMerge(false)">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="cancelMerge(true)">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>